/**
 * Maintained by Sandon.
 */
export default {
  name: 'sy-option',
  inject: ['select'],
  props: {
    value: {required: true},
    label: [String, Number],
    disabled: {type: Boolean, default: false}
  },
  data () {
    return {
    }
  },
  watch: {
    'disabled': function () {
      this.select.update()
    }
  },
  created () {
    this.select.onOptionAdd(this)
  },
  beforeDestroy () {
    // this.select.onOptionDestroy(this.select.options.indexOf(this))
    this.select.onOptionDestroy(this)
  },
  render (h) {}
}
